import { View } from "react-native";
import GoBack from "ui/molecules/common/GoBack";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { ComponentRef, useRef } from "react";
import AssessmentSectionLinks from "../organisms/AssessmentSectionLinks";
import { useAssessmentFormContext } from "../../assessments/providers/AssessmentFormProvider";
import AssessmentFormTemplate from "./AssessmentFormTemplate";
import { useResidentLayoutContext } from "app/features/residents/provider/ResidentLayoutProvider";

type Props = {
  isFetching?: boolean;
  backPath?: string;
};

export default function AssessmentReportTemplate({
  isFetching,
  backPath,
}: Props) {
  const { sections, assessmentModel } = useAssessmentFormContext();

  const { scrollTo } = useResidentLayoutContext();

  const sectionRefs = useRef<{
    [key: number]: ComponentRef<typeof View>;
  }>({});

  const handleMenuItemClick = (sectionId: number) => {
    const sectionRef = sectionRefs.current[sectionId];
    if (sectionRef) {
      scrollTo(sectionRef);
    }
  };

  return (
    <View className="bg-white flex-1 items-start pb-10">
      {isFetching ? (
        <View className="flex-1 self-center py-10 bg-white">
          <LoadingSpinner />
        </View>
      ) : (
        <View className="grid grid-cols-12 gap-x-6 lg:gap-x-12 w-full mt-4">
          <View className="md:col-span-4 hidden md:block">
            <View className="sticky top-[180px] flex-col items-start gap-4">
              {backPath ? <GoBack path={backPath} /> : null}
              <AssessmentSectionLinks
                form={assessmentModel}
                sections={sections}
                onMenuItemClick={handleMenuItemClick}
              />
            </View>
          </View>
          <View className="md:col-span-8 col-span-12 md:mt-12">
            <AssessmentFormTemplate
              sectionRefs={sectionRefs}
              cancelPath={backPath}
            />
          </View>
        </View>
      )}
    </View>
  );
}
